import { Dialog, DialogProps } from "primereact/dialog";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/Reduxstore";

interface ReusablePrimeReactDialogProps extends DialogProps {
  allowedRoles?: string[]; // ✅ Optional role-based rendering
}

const ReusablePrimeReactDialog: React.FC<ReusablePrimeReactDialogProps> = ({
  allowedRoles,
  ...props
}) => {
  const userDetails = useSelector((state: RootState) => state.auth);

  // ✅ If roles are provided, check if user is authorized
  if (allowedRoles?.length) {
    const hasAccess = userDetails?.role?.some((r: any) =>
      allowedRoles.includes(r.roleName)
    );
    if (!hasAccess) return null;
  }

  return (
    <div className="p-dialog">
      <Dialog {...props} />
    </div>
  );
};

export default ReusablePrimeReactDialog;